export class CreatePostDTO {
  caption: string = "";
  type: string = ""; // default to "post", or customize if needed
  location: string = "";
  mediaIds: number[] = [];

  constructor(data: Partial<Omit<CreatePostDTO, 'mediaIds'> & { mediaIds?: string | number[] }> = {}) {
    if (typeof data.mediaIds === 'string') {
      this.mediaIds = data.mediaIds
        .split(',')
        .map(id => parseInt(id.trim(), 10))
        .filter(id => !isNaN(id));
    } else if (Array.isArray(data.mediaIds)) {
      this.mediaIds = data.mediaIds;
    } else {
      this.mediaIds = [];
    }

    Object.assign(this, data);
  }
}
